import React, { useContext } from 'react';
import { ProjectsList } from '@components/projects';
import DashboardWheelsSection from '@components/charts/DashboardWheelsSection';
import { WithPermission } from '@lib/helpers/WithPermission';
import { UserContext } from '@components/contexts/UserProvider';
import EnteEroganteProjectsList from '@components/projects/EnteEroganteProjectsList';

const Projects = () => {
	const {
		userAccess: { isGuestEnteErogante },
	} = useContext(UserContext);

	return (
		<div id="progetti" className="megaContent">
			<div className="container-fluid">
				<h1
					className="fw-bold"
					style={{
						marginBlock: '24px 28px',
						paddingBlock: '3px',
					}}
				>
					Progetti
				</h1>

				<WithPermission permission="view-landing-charts">
					<DashboardWheelsSection global={true} />
				</WithPermission>
				<WithPermission permission="view-projects-list">
					{!isGuestEnteErogante ? <ProjectsList /> : null}
					{isGuestEnteErogante ? <EnteEroganteProjectsList /> : null}
				</WithPermission>
			</div>
		</div>
	);
};

export default Projects;
